import React from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { useGetDeliveryAttemptsHandler } from '../../deliveryAttempts/dataHandlers/getDeliveryAttemptsHandler';
import DeliveryAttemptsList from '../../deliveryAttempts/components/DeliveryAttemptsList';

/**
 * DeliveryAttemptsSection component handles fetching and displaying delivery attempts
 * @param {string} eventId - The event ID to fetch delivery attempts for
 */
const DeliveryAttemptsSection = ({ eventId }) => {
  const { attempts, isLoading, isError, error } = useGetDeliveryAttemptsHandler({ eventId });

  if (isError) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 500, mb: 0.5 }}>
          Deliveries to webhook endpoints
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 2 }}>
          Attempts to send this event to your webhook endpoints in the past 15 days.
        </Typography>
        <Alert severity="error" sx={{ mt: 2 }}>
          {error?.response?.status === 404 ? 'Delivery attempts not found' : 'Failed to load delivery attempts'}
        </Alert>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 500, mb: 0.5 }}>
          Deliveries to webhook endpoints
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', mb: 2 }}>
          Attempts to send this event to your webhook endpoints in the past 15 days.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      </Box>
    );
  }

  return <DeliveryAttemptsList attempts={attempts} />;
};

export default DeliveryAttemptsSection;
